import { User } from '../types/user';
import { httpClient } from './httpClient';

export interface GroupAgent {
    id: number;
    group_id: number;
    user_id: number;
    created_at: string;
    updated_at: string;
}

export const groupAgentsService = {
    getAgentsByGroupId: async (groupId: number): Promise<GroupAgent[]> => {
        return httpClient.get<GroupAgent[]>(`/api/group-agents/${groupId}/agents`);
    },

    getAvailableAgents: async (groupId: number): Promise<User[]> => {
        return httpClient.get<User[]>(`/api/group-agents/${groupId}/available-agents`);
    },

    addAgentToGroup: async (groupId: number, userId: number): Promise<GroupAgent> => {
        return httpClient.post(`/api/group-agents/${groupId}/agents`, { user_id: userId });
    },

    addAgentsToGroup: async (groupId: number, userIds: number[]): Promise<void> => {
        const data = { user_ids: userIds };
        return httpClient.post(`/api/group-agents/${groupId}/agents/bulk`, data);
    },

    removeAgentFromGroup: async (groupId: number, userId: number): Promise<void> => {
        return httpClient.delete(`/api/group-agents/${groupId}/agents/${userId}`);
    },

    removeAgentsFromGroup: async (groupId: number, userIds: number[]): Promise<void> => {
        // Send each user ID as a separate query parameter
        const params = { params: { user_ids: userIds } };
        return httpClient.delete(`/api/group-agents/${groupId}/agents/bulk`, params);
    }
};
